<template>
  <button
    type="button"
    v-if="showPlaceholder"
    class="w-14 h-14 rounded-full bg-white shadow-2xl fixed z-50 bottom-10 right-5 flex items-center justify-center"
    @click="showConsent = true"
  >
    <ChatbotIcon class="h-9 text-blackly-dark" />

    <Modal v-if="showConsent" :showing="showConsent" @close="showConsent = false">
      <div class="w-full p-4">
        <h3 class="fluid-lg mb-4">{{ t('chatbot.consent.title') }}</h3>
        <p class="mb-6">
          {{ t('chatbot.consent.message') }} <br />
          <button class="font-bold underline" type="button" @click="openCookieBanner">
            {{ t('onetrust.categories.marketing') }}
          </button>
        </p>

        <div class="flex gap-2 flex-wrap">
          <button class="btn-pill-green" @click="acceptMarketingCookies">{{ t('chatbot.consent.accept') }}</button>
          <button class="btn-pill-white" @click="showConsent = false">{{ t('close') }}</button>
        </div>
      </div>
    </Modal>
  </button>
</template>

<script setup>
import ChatbotIcon from '@/components/icons/ChatbotIcon.vue';
import Modal from '@/components/common/Modal.vue';

const { t } = useI18n();
const showPlaceholder = ref(true);
const showConsent = ref(false);

const checkForBotfriendsWebchat = () => {
  if (typeof BotfriendsWebchat === 'undefined') {
    console.warn('BotfriendsWebchat is not loaded');
    return;
  }

  showPlaceholder.value = false;
};

const openCookieBanner = () => {
  if (window && window.OneTrust) {
    showConsent.value = false;
    window.OneTrust.ToggleInfoDisplay();
  }
};

const acceptMarketingCookies = () => {
  if (window && window.OneTrust) {
    window.OneTrust.UpdateConsent('Category', 'C0004:1');
    showConsent.value = false;
  }
};

onMounted(() => {
  checkForBotfriendsWebchat();
  window.addEventListener('oneTrustReady', checkForBotfriendsWebchat);
});
</script>
